<template>
  <el-dialog
    class="common_pdfviewer_wrapper"
    :title="title === '' ? 'PDF Viewer' : title"
    :visible.sync="visible"
    :close="handleClose"
    ref="pdfviewer"
    top="80px"
    width="1100px"
  >
    <div class="maincontent">
      <div class="header">
        <el-button v-if="!!download" @click="handleDownloadFile2">{{
          $t('btn.download')
        }}</el-button>
        <!-- <el-button @click='handleDownloadFile2'>{{$t('btn.download')}}</el-button> -->
      </div>
      <div class="main" :class="{ download: !!download }">
        <div class="operator">
          <el-button
            type="text"
            icon="el-icon-arrow-left"
            @click="handlePrevious"
            :disabled="atBegining"
          ></el-button>
        </div>
        <div class="content">
          <canvas id="the-canvas" :style="canvasStyle"></canvas>
        </div>
        <div class="operator">
          <el-button
            type="text"
            icon="el-icon-arrow-right"
            @click="handleNext"
            :disabled="atEnd"
          ></el-button>
        </div>
      </div>
      <div class="footer" v-if="pagination.limit > 1">
        <el-pagination          
          layout="prev, pager, next"
          :page-size="1"
          :total="pagination.limit"
          :current-page.sync="pagination.page"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
let loadingTask;

import pdfjsLib from 'pdfjs-dist/es5/build/pdf.js';
import { baseURL } from '@/util/axios';

export default {
  name: 'PDFViewer',
  props: {
    fileData: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    download: {
      type: Boolean,
      default: false,
      require: false
    },
    s3Path: {
      type: String,
      default: '',
      require: false
    }
  },
  data() {
    return {
      innerData: {},
      title: '',
      fileName: 'file',
      visible: false,
      canvasVisible: false,
      flipingFlag: false,
      pagination: {
        page: 1,
        limit: null
      },
      canvasStyle: {
        opacity: 0,
        transition: 'all 1s'
      }
    };
  },
  computed: {
    atBegining() {
      return this.pagination.page === 1;
    },
    atEnd() {
      return this.pagination.page === this.pagination.limit;
    }
  },
  watch: {
    fileData(value) {
      this.innerData = value;
    },
    async innerData(value) {
      value = value.data ? value.data : value;
      let base64Data = '';
      if (typeof value === 'string' && this.isBase64(value)) {
        base64Data = value;
      } else if (value instanceof Blob) {
        base64Data = await this.blobToBase64(value);
      } else {
        base64Data = await this.arraybufferToBase64(value);
      }
      this.base64Data = base64Data;
      this.init(base64Data);
    },
    visible(value) {
      if (!value) {
        this.pagination.page = 1;
        this.canvasStyle.opacity = 0;
      } else {
        const canvas = document.getElementById('the-canvas');
        if (canvas) {
          canvas.scrollTop = 0;
        }
      }
    }
  },
  mounted() {},

  methods: {
    handleClose() {
      this.visible = false;
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (event) => {
            resolve(event.target.result);
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    arraybufferToBase64(data) {
      return new Promise((resolve, reject) => {
        try {
          const blob = new Blob([data]);
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (event) => {
            resolve(event.target.result);
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    async init(base64Data) {
      // 获取当前主机地址和端口号
      const protocol = window.location.protocol;

      // const host = window.location.host;
      // const workerFileLocation = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/build/pdf.worker.min.js';
      // const workerFileLocation = '/static/js/pdf.worker.min.js';
      //   const workerFileLocation = './static/js/pdf.worker.es5.min.js';
      const workerFileLocation = './static/js/pdf.worker.js';

      // set pdf worker
      base64Data = base64Data.substr(
        base64Data.indexOf('base64,') + 7,
        base64Data.length
      );

      pdfjsLib.GlobalWorkerOptions.workerSrc = workerFileLocation;
      const CMAP_URL = './static/fonts/pdfjs/cmaps/';
      // pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.js");
      try {
        loadingTask = pdfjsLib.getDocument({
          data: atob(base64Data),
          cMapUrl: CMAP_URL,
          cMapPacked: true
        });
        // console.log(loadingTask)
        this.renderPage(base64Data);
      } catch (error) {
        console.log(error);
        this.$messageBox({
          icon: 'error', // --->弹窗类型 非必填 [success √,warning ！,error X]
          title: this.$t('pdfViewer.data_error') + '3', // -->副标题 非必填
          btnText: this.$t('Confirm')
        });
      }
    },
    async renderPage(base64Data) {
      const pdf = await loadingTask.promise;
      console.log('loadingTask.promise');
      // const pdfFile = 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf'
      console.log('renderPage++++');
      console.log(pdf);

      this.pagination.limit = pdf.numPages;
      pdf
        .getPage(this.pagination.page)
        .then((page) => {
          // you can now use *page* here
          var scale = 2;
          var viewport = page.getViewport({ scale: scale });
          var canvas = document.getElementById('the-canvas');
          var context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          var renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          page.render(renderContext);

          setTimeout(() => {
            this.canvasStyle = {
              opacity: 1,
              transition: 'all 0.3s'
            };
          }, 500);

          // this.canvasVisible = false;

          setTimeout(() => {
            this.canvasVisible = true;
          }, 2500);
        })
        .catch((error) => {
          this.$messageBox({
            icon: 'error', // --->弹窗类型 非必填 [success √,warning ！,error X]
            title: this.$t('pdfViewer.data_error') + '2', // -->副标题 非必填
            btnText: this.$t('Confirm')
          });
          console.log('error 2+++++++');
          console.log(error);
        });
    },
    handleGoPage(pageNumber) {
      if (this.pagination.page > this.pagination.limit) {
        return;
      }

      this.pagination.page = pageNumber;
      this.canvasStyle = {
        transition: 'all 0s',
        opacity: 0
      };

      this.renderPage();
    },
    handlePrevious() {
      if (this.flipingFlag) {
        return false;
      }
      this.flipingFlag = false;
      const pageNumber =
        this.pagination.page > 1 ? this.pagination.page - 1 : 1;
      this.handleGoPage(pageNumber);
      setTimeout(() => {
        this.flipingFlag = false;
      }, 500);
    },
    handleNext() {
      if (this.flipingFlag) {
        return false;
      }
      this.flipingFlag = false;
      const pageNumber =
        this.pagination.page < this.pagination.limit
          ? this.pagination.page + 1
          : this.pagination.limit;

      this.handleGoPage(pageNumber);
      setTimeout(() => {
        this.flipingFlag = false;
      }, 500);
    },
    handleCurrentChange(pageNumber) {
      this.handleGoPage(pageNumber);
    },
    isBase64(str) {
      if (str === '' || str.trim() === '') {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },

    handleDownloadStreamData() {
      const blob = this.dataURLtoBlob(this.base64Data);
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, this.title);
      } else {
        // location.href = URL.createObjectURL(blob);
        const eleLink = document.createElement('a');
        eleLink.download =
          !!this.title && this.title !== ''
            ? this.title
            : 'fIle_' + Date.parse(new Date());
        eleLink.style.display = 'none';
        eleLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eleLink);
        eleLink.click();
      }
    },
    handleDownloadFile2() {
      const s3Path = this.s3Path;

      if (!!s3Path && s3Path !== '') {
        let result = '';
        if (!!this.fileName && this.fileName !== 'file') {
          // 有传文件名
          const fileName = this.fileName.replace('.pdf', '');
          result = `${baseURL}/e2estservice/meeting/meetingFile/downloadFileWithName?url=${encodeURIComponent(
            s3Path
          )}`;
          result += `&filename=${fileName}.pdf`;
        } else {
          // 没有传文件名
          result =
            baseURL +
            '/e2estservice/meeting/meetingFile/downloadFile?url=' +
            encodeURIComponent(s3Path);
        }

        console.log(result);

        const aTag = document.createElement('a');
        aTag.href = result;
        aTag.target = '_blank';
        // aTag.download = this.title || 'file.pdf';
        aTag.click();
      } else {
        this.handleDownloadStreamData();
      }
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    myBrowser() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf('Opera') > -1; // 判断是否Opera浏览器
      var isIE =
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1 &&
        !isOpera; // 判断是否IE浏览器
      var isEdge = userAgent.indexOf('Edge') > -1; // 判断是否IE的Edge浏览器
      var isFF = userAgent.indexOf('Firefox') > -1; // 判断是否Firefox浏览器
      var isSafari =
        userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1; // 判断是否Safari浏览器
      var isChrome =
        userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1; // 判断Chrome浏览器

      if (isIE) {
        // var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        // reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion == 7) {
          return 'IE7';
        } else if (fIEVersion == 8) {
          return 'IE8';
        } else if (fIEVersion == 9) {
          return 'IE9';
        } else if (fIEVersion == 10) {
          return 'IE10';
        } else if (fIEVersion == 11) {
          return 'IE11';
        } else {
          return '0';
        } // IE版本过低
        // return 'IE';
      }
      if (isOpera) {
        return 'Opera';
      }
      if (isEdge) {
        return 'Edge';
      }
      if (isFF) {
        return 'FF';
      }
      if (isSafari) {
        return 'Safari';
      }
      if (isChrome) {
        return 'Chrome';
      }
    },
    downloadByForm(s3Path) {
      const form = document.createElement('form');
      const iframe = document.createElement('iframe');
      form.target = 'aaa';
      iframe.id = 'aaa';
      iframe.name = 'aaa';
      form.method = 'POST';
      form.action = s3Path;
      document.body.appendChild(iframe);
      document.body.appendChild(form);
      form.submit();
    }
  }
};
</script>

<style lang="less">
.common_pdfviewer_wrapper {
  z-index: 10000 !important;
  .el-dialog__body {
    padding: 0 20px 30px 20px;
  }
  .maincontent {
    height: 75vh;
    text-align: center;
    .header {
      margin: 0 auto 20px;
      padding: 10px 30px;
      width: 100%;
      text-align: right;
      position: absolute;
      left: 0;
      top: 50px;
    }
    .main {
      padding: 0 0 10px 0;

      height: 100%;
      &.download {
      }
      .content {
        display: inline-block;
        margin: 0 50px;
        width: 800px;
        height: 100%;
        overflow: auto;
        vertical-align: middle;
        &:before {
          content: '';
          display: inline-block;
          width: 0;
          height: 100%;
          vertical-align: middle;
        }
        canvas {
          display: inline-block;
          // margin: 0 auto;
          padding: 0 0 1rem 0;
          width: 100%;
          // width: calc(100% - 100px);
          vertical-align: middle;
        }
      }

      .operator {
        display: inline-block;
        // padding: 0 30px;
        width: 60px;
        // height: 50px;
        vertical-align: middle;
        // position: absolute;
        // bottom: 0;
        // left: 0;
        z-index: 1;
        i {
          font-size: 60px;
        }
        .el-button {
          padding: 0;
          height: auto;
          &.is-disabled {
            border-color: transparent;
          }
        }
        .left {
          display: inline-block;
          width: 100px;
          height: 50px;
          background-color: red;
        }

        .right {
          display: inline-block;
          width: 100px;
          height: 50px;
          background-color: red;
        }
      }
    }
    .footer {
      margin: 0 0 10px 0;
      width: 100%;
      position: absolute;
      bottom: 0;
      .el-pagination {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// PDFViewer.vue?50998936